import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AutoTaggingSystem from "./AutoTaggingSystem";
import BulkContentProcessor from "./BulkContentProcessor";
import ContentRecommendations from "./ContentRecommendations";
import AdaptiveLearningPaths from "./AdaptiveLearningPaths";
import { Tags, Zap, Lightbulb, TrendingUp } from "lucide-react";

export default function AISmartEnhancement() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card className="border-primary/20 bg-gradient-to-br from-background to-primary/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <Tags className="h-4 w-4 text-primary" />
              Auto-Tagging
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Intelligent content categorization and tagging
            </p>
          </CardContent>
        </Card>

        <Card className="border-warning/20 bg-gradient-to-br from-background to-warning/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <Zap className="h-4 w-4 text-warning" />
              Bulk Processing
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Process multiple content items efficiently
            </p>
          </CardContent>
        </Card>

        <Card className="border-success/20 bg-gradient-to-br from-background to-success/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <Lightbulb className="h-4 w-4 text-success" />
              Recommendations
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              AI-powered content suggestions
            </p>
          </CardContent>
        </Card>

        <Card className="border-destructive/20 bg-gradient-to-br from-background to-destructive/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <TrendingUp className="h-4 w-4 text-destructive" />
              Learning Paths
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Adaptive learning progression
            </p>
          </CardContent>
        </Card>
      </div>

      <Tabs defaultValue="tagging" className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="tagging" className="flex items-center gap-2">
            <Tags className="h-4 w-4" />
            Auto-Tagging
          </TabsTrigger>
          <TabsTrigger value="bulk" className="flex items-center gap-2">
            <Zap className="h-4 w-4" />
            Bulk Process
          </TabsTrigger>
          <TabsTrigger value="recommendations" className="flex items-center gap-2">
            <Lightbulb className="h-4 w-4" />
            Recommendations
          </TabsTrigger>
          <TabsTrigger value="learning" className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            Learning Paths
          </TabsTrigger>
        </TabsList>

        <TabsContent value="tagging" className="mt-6">
          <AutoTaggingSystem />
        </TabsContent>

        <TabsContent value="bulk" className="mt-6">
          <BulkContentProcessor />
        </TabsContent>

        <TabsContent value="recommendations" className="mt-6">
          <ContentRecommendations />
        </TabsContent>

        <TabsContent value="learning" className="mt-6">
          <AdaptiveLearningPaths />
        </TabsContent>
      </Tabs>
    </div>
  );
}